// Generated by Melange

import * as ReactRouter from "@tanstack/react-router";

const route = ReactRouter.createRootRoute({});

export {
  route,
}
/* route Not a pure module */
